const announcements = document.querySelector(".ts-announcements-bar");
const announcementsCloser = document.querySelector(".ts-announcements-bar__closer");

announcementsCloser.addEventListener("click", () => {
  announcements.classList.add("hidden");
});

const menuItems = document.querySelectorAll(".ts-header__megamenus-item.has-children");

menuItems.forEach((item) => {
  const link = item.querySelector(".ts-header__megamenus-link");

  link.addEventListener("click", function (e) {
    e.preventDefault();

    menuItems.forEach((el) => {
      if (el !== item) {
        el.classList.remove("active");
      }
    });

    item.classList.toggle("active");
  });
});

document.addEventListener("click", function (e) {
  if (!e.target.closest(".ts-header__megamenus")) {
    menuItems.forEach((item) => item.classList.remove("active"));
  }
});

const toggleBtn = document.querySelector(".ts-header__hero-all-cats-megamenu");
const menuContainer = document.querySelector(".ts-header__categories-menu");

if (toggleBtn && menuContainer) {
  toggleBtn.addEventListener("click", function () {
    menuContainer.classList.toggle("active");
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".ts-header__hero-all-cats-megamenu") && !e.target.closest(".ts-header__categories-menu")) {
      menuContainer.classList.remove("active");
    }
  });
}

const mobileMenuOpener = document.querySelector(".ts-header__hero-burger-opener_mobile");
const mobileMenu = document.querySelector("#mainMobileMenu");

mobileMenuOpener.addEventListener("click", () => {
  mobileMenu.classList.toggle("active");
  mobileMenuOpener.classList.toggle("active");
  if (mobileCategories.classList.contains("active")) {
    mobileCategories.classList.remove("active");
  }
  documentChecker();
});

const mobileCategoriesOpener = document.querySelector(".ts-header_mobile-menu__btn");
const mobileCategories = document.querySelector("#categoriesMobileMenu");

if (Shopify.designMode) {
  if (mobileCategories) {
    mobileCategories.style.display = "none";
  }
  if (mobileMenu) {
    mobileMenu.style.display = "none";
  }
}

mobileCategoriesOpener.addEventListener("click", () => {
  mobileCategories.classList.add("active");
  documentChecker();
});

const documentChecker = function () {
  if (mobileMenu.classList.contains("active") || mobileMenuOpener.classList.contains("active") || mobileCategories.classList.contains("active")) {
    document.documentElement.classList.add("no-scroll");
  } else {
    document.documentElement.classList.remove("no-scroll");
  }
};

document.querySelectorAll(".categories-mobile-menu__toggle").forEach((toggleBtn) => {
  toggleBtn.addEventListener("click", (e) => {
    e.preventDefault();
    const parentItem = e.currentTarget.closest(".categories-mobile-menu__item");
    parentItem.classList.toggle("active");
  });
});
